common.View.create('galaxy::common.form.inputs.Richtext', {

    ckEditor: null,
    allowBlurOnce: false,

    onDOMLoad()
    {
        this.initCkeditor();
    },

    initCkeditor()
    {
        // Get textarea.
        let textarea = this.element.find('textarea').get(0);

        // Init Ckeditor.
        CKEDITOR.inline(textarea, this.getOptions());
    },

    getOptions()
    {
        let options = {

            extraPlugins: 'link,colorbutton,sourcedialog,justify,embed,autoembed,dialogadvtab',

            // Needed so CKeditor doesn't remove image advanced by default
            removeDialogTabs: '',

            embed_provider: '//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}',

            colorButton_colors: this.initTailwindConfigColors().join(','),

            stylesSet: [],

            versionCheck: false,

            // Toolbar
            toolbarGroups: [
                { name: 'document', groups: [ 'mode', 'document', 'doctools', 'source', 'embed' ] },
                { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
                { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
                { name: 'forms', groups: [ 'forms' ] },
                { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },
                { name: 'link', groups: [ 'links' ] },
                { name: 'insert', groups: [ 'insert' ] },
                { name: 'styles', groups: [ 'styles', 'colors' ] },
            ],
            removeButtons: 'PasteFromWord,Paste,Copy,Replace,Find,SelectAll,Scayt,Form,Checkbox,Radio,Textarea,Select,TextField,Button,HiddenField,Save,Preview,Print,NewPage,Templates,Strike,Subscript,Superscript,RemoveFormat,CopyFormatting,Outdent,Indent,Blockquote,CreateDiv,JustifyBlock,Language,BidiRtl,BidiLtr,Anchor,Flash,HorizontalRule,PageBreak,Iframe,FontSize,Font,BGColor,ShowBlocks,Maximize,About,SpecialChar',

            extraAllowedContent: 'iframe[*]; p a h2 h3 h4 h5(*)',

            format_tags: 'p;h2;h3;h4;h5',

            enterMode : CKEDITOR.ENTER_P,
            shiftEnterMode: CKEDITOR.ENTER_BR,
            autoParagraph: false,

            language: 'nl',

            on: {
                instanceReady: this.onCkeditorLoaded.bind(this),
            },
        };

        // Apply app options.
        options = require('./../../../../../../../../resources/js/common/form/inputs/richtext.js')(options);

        //
        return options;
    },

    initTailwindConfigColors()
    {
        // Grab tailwind config
        let tailwindConfig = require('./../../../../../../../../tailwind.config.js');

        // Get colors from config
        let tailwindConfigColors = Object.values(tailwindConfig.theme.extend.colors.palette);

        // Remove #'s from arrays
        tailwindConfigColors = tailwindConfigColors.map(color => color.replace('#', ''));

        // Add standard additional colors
        tailwindConfigColors = [
            'transparent',
            '#ffffff',
            '#000000',
            ...tailwindConfigColors,
        ];

        // Return colors array
        return tailwindConfigColors;
    },

    onCkeditorLoaded(event)
    {
        // Set
        this.ckEditor = event.editor;

        //
        CKFinder.setupCKEditor(this.ckEditor);
    }

});
